import { render, staticRenderFns } from "./ManageCodelist.vue?vue&type=template&id=3156e43f&scoped=true&"
import script from "./ManageCodelist.vue?vue&type=script&lang=js&"
export * from "./ManageCodelist.vue?vue&type=script&lang=js&"
import style0 from "./ManageCodelist.vue?vue&type=style&index=0&id=3156e43f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3156e43f",
  null
  
)

/* custom blocks */
import block0 from "./ManageCodelist.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports